/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { closelightbox } from "../../util/Functions";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, MenuItem } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";
import moment from "moment";

const InfoPersonal = (props) => {
  const history = useHistory();
  const [zPos, setZPos] = useState(45);
  const [content, setContent] = useState({});
  const [disabled, setDisabled] = useState(true);
  const [sendRisk, setSendRisk] = useState(false);
  const [valueRisk, setValueRisk] = useState("");
  const [occupationCatalog, setOccupationCatalog] = useState("");

  useEffect(() => {
    var clone = Object.assign({}, props.contentModal.general);
    setValueRisk(clone.risk);
    let roles = localStorage.config && JSON.parse(localStorage.config)["idRol"] ? [JSON.parse(localStorage.config)["idRol"]] : [];
    if ( roles.indexOf("inext-role-customerService-manager") == -1 && roles.indexOf("inext-role-customerService-specialist") == -1) {
      setDisabled(false);
    }
    if (clone["originAppUUID"] === "3") {
      clone["populationid"] = "";
    }
    setContent(clone);
    setOccupationCatalog( clone["originAppUUID"] === "3" ? "economicActivities" : "occupations");
  }, []);

  const changeValue = (type, name, e) => {
    let c = content;
    if (type == "date") {
      c[name] = new Date(e.target.value).toJSON().substr(0, 10);
    } else {
      c[name] = e.target.value;
    }

    setContent(JSON.parse(JSON.stringify(c)));
  };

  const update = async () => {
    props.changeLoader(true);
    setZPos(-1);

    if (content["taxid"]) {
      content["taxid"] = content["taxid"].toUpperCase();
    }
    if (content["populationid"]) {
      content["populationid"] = content["populationid"].toUpperCase();
    }
    let slname = "";
    if (content["slname"]) {
      slname = content["slname"];
    }
    let data = {
      customer: {
        uuid: content["uuid"],
        general: {
          bdate: content["bdate"],
          gender: content["originAppUUID"] === "3" ? undefined : content["gender"],
          phone: content["phone"]?.trim() ? content["phone"]?.trim() : "",
          slname: slname?.trim() ? slname?.trim() : "",
          gname: content["gname"]?.trim() ? content["gname"]?.trim() : "",
          lname: content["lname"]?.trim() ? content["lname"]?.trim() : "",
          email: content["email"]?.trim() ? content["email"]?.trim() : "",
          bcountry: content["bcountry"],
          risk: sendRisk ? content["risk"] : "",
          bstate: content["bstate"],
          occupation: content["occupation"],
          taxid: content["taxid"]?.trim() ? content["taxid"]?.trim() : "",
          populationid: content["populationid"]?.trim() ? content["populationid"]?.trim(): "",
          statusValidation: content["statusValidation"],
          reasonReject: content["reasonReject"],
        },
      },
    };
    if(content["onboarding_type"] === "n1"){
      data.customer.general["onboarding_type"] = content["onboarding_type"]
    }

    if (content.hasOwnProperty("corporate_name")) {
      data.customer.general["corporate_name"] = content["corporate_name"];
      data.customer.general["lname"] = content["corporate_name"];
    }

    let updateInfo = await API.service( "updateProfile", data, props.pos, props.changeAlert, props.changeLoader, history );

    if (updateInfo.status == 200) {
      if (updateInfo.data.data.response == "OK") {
        await props.reloadData(data.customer.uuid);
        props.changeUpdate(moment().format("x"));

        await props.contentModal.widgets.map(async (i) => {
          if (i.type === "manualCheckList") {
            props.changeLoader(true);
            setZPos(-1);

            let widgetsCompliance = await API.service( "complianceInitByUUID", data.customer.uuid, props.pos, props.changeAlert, props.changeLoader, history );
            if (widgetsCompliance.status == 200) {
              if (widgetsCompliance.data.data.response == "OK") {
                await props.contentModal.changeWidgets(
                  widgetsCompliance.data.data.widget
                );
              }
            }
          }
        });

        setTimeout(() => {
          props.changeAlert(true, "success", "Datos actualizados con éxito");
        }, 2000)
      } 
    } 
    setTimeout(() => {
      closelightbox();
      setZPos(45);
      props.changeLoader(false);
    }, 2000)

  };

  return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(false)}>
        <DialogTitle >
          {content["title"]}
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>				
      
        <DialogContent style={{overflowY: "hidden"}}>
          <Grid container spacing={2} style={{marginTop: "10px"}}>
            {!disabled && content["originAppUUID"] !== "3" &&
              <Grid item md={6} xs={12} >
                <img src={content["front_image"]} />
              </Grid>
            }
            <Grid item container spacing={2} md={!disabled ? 6 : 12} xs={12} >
              {content["originAppUUID"] !== "3" ?
                <>
                  <Grid item xs={!disabled ? 12 : 6} >
                    <TextField label="Nombre(s)" value={content["gname"] || ""} onChange={changeValue.bind(this, "text", "gname")} disabled={disabled} size="small" fullWidth/>
                  </Grid>
                  <Grid item xs={!disabled ? 12 : 6} >
                    <TextField label="Apellido paterno" value={content["lname"] || ""} onChange={changeValue.bind(this, "text", "lname")} disabled={disabled} size="small" fullWidth/>
                  </Grid>
                  <Grid item xs={!disabled ? 12 : 6} >
                    <TextField label="Apellido materno" value={content["slname"] || ""} onChange={changeValue.bind(this, "text", "slname")} disabled={disabled} size="small" fullWidth/>
                  </Grid>
                </>
                :
                  <Grid item xs={!disabled ? 12 : 6} >
                    <TextField label="Razón Social" value={content["corporate_name"] || ""} onChange={changeValue.bind(this, "text", "corporate_name")} disabled={disabled} size="small" fullWidth/>
                  </Grid>
              }

              {content["originAppUUID"] !== "3" && !disabled &&
                <Grid item xs={12}>
                  <TextField
                    label="Fecha de Nacimiento"
                    value={content["bdate"] ? new Date(content["bdate"]).toJSON().substr(0, 10) : content["bdate"]}
                    onChange={changeValue.bind(this, "date", "bdate")}
                    type={"date"}
                    size="small"
                    fullWidth
                    InputLabelProps={{ shrink: true }}								
                  />
                </Grid>
              }
              {disabled &&
                <Grid item xs={6}>
                  <TextField label="No. celular" value={content["phone"] || ""} onChange={changeValue.bind(this, "text", "phone")} size="small" fullWidth/>
                </Grid>
              }
            </Grid>
            {content["originAppUUID"] !== "3" && !disabled &&
              <Grid item xs={6}>
                <TextField  
                  label="Género" value={content["gender"] || ""}  onChange={changeValue.bind(this, "select", "gender")} select size="small" fullWidth  >
                  {props.contentModal.catalogs?.gender?.map((item, index) => (
                    <MenuItem key={`gender-${index}`} value={item.k}>{item.v}</MenuItem>
                  ))}
                </TextField>
              </Grid>
            }
            {content["originAppUUID"] === "3" &&
              <Grid item xs={6} >
                <TextField label="Nombre Comercial" value={content["gname"] || ""} onChange={changeValue.bind(this, "text", "gname")} disabled={disabled} size="small" fullWidth/>
              </Grid>
            }
            <Grid item xs={6}>
              <TextField
                label="Email" value={content["email"] || ""} onChange={changeValue.bind(this, "text", "email")} size="small" fullWidth inputProps={{style: {fontSize: "14px"}}} />
            </Grid>
            {content["originAppUUID"] !== "3" && !disabled ?
              <Grid item xs={6}>
                <TextField
                  label="Lugar de nacimiento" value={content["bcountry"] || ""} select onChange={changeValue.bind(this, "select", "bcountry")} size="small" fullWidth >
                  {props.contentModal.catalogs?.country?.map((item, index) => (
                    <MenuItem key={`country-${index}`} value={item.k}>{item.v}</MenuItem>
                  ))}
                </TextField>
              </Grid>
              :
              <>
                <Grid item xs={6}>
                  <TextField
                    label="Lugar de constitución" value={content["bcountry"] || ""} select onChange={changeValue.bind(this, "select", "bcountry")} size="small" fullWidth >
                    {props.contentModal.catalogs?.country?.map((item, index) => (
                      <MenuItem key={`country-${index}`} value={item.k}>{item.v}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label="Fecha de constitución"
                    value={content["bdate"] ? new Date(content["bdate"]).toJSON().substr(0, 10) : content["bdate"]}
                    onChange={changeValue.bind(this, "date", "bdate")}
                    type={"date"}
                    size="small"
                    fullWidth
                    InputLabelProps={{ shrink: true }}								
                  />
                </Grid>
              </>
            
            }
            {!disabled &&
              <Grid item xs={6}>
                <TextField label="No. celular" value={content["phone"] || ""} onChange={changeValue.bind(this, "text", "phone")} size="small" fullWidth/>
              </Grid>
            }
            {!disabled && 
              <Grid item xs={6}>
                <TextField  
                  label="Ocupación" value={content["occupation"] || ""} onChange={changeValue.bind(this, "select", "occupation")} select size="small" fullWidth >
                  {props.contentModal["catalogs"]?.[occupationCatalog]?.map((item, index) => (
                    <MenuItem key={`occupation-${index}`} value={item.k}>{item.v}</MenuItem>
                  ))}
                </TextField>
              </Grid>
            }
            {!disabled && 
              <Grid item xs={6}>
                <TextField label="RFC" value={content["taxid"] || ""} onChange={changeValue.bind(this, "text", "taxid")} size="small" fullWidth/>
              </Grid>
            }
            {!disabled && content["originAppUUID"] !== "3" && 
              <Grid item xs={6}>
                <TextField label="CURP" value={content["populationid"] || ""} onChange={changeValue.bind(this, "text", "populationid")} size="small" fullWidth/>
              </Grid>
            }
          </Grid>
        </DialogContent>

        <DialogActions>    
          <Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>     
          <Button onClick={update.bind(this)}>Guardar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog>    
  );
};

export default InfoPersonal;
